import React, { FC } from 'react';
import styled from '@emotion/styled';
import shouldForwardProp from '@styled-system/should-forward-prop';

import { Box, Flex } from '../../..';
import sx from '../../../internal/styles/sx';
import { WithDivProps } from '../../../internal/styles/types';
import wavesEffect from '../wavesEffect';
import { SkeletonButtonProps } from './types';
import base from './variants/base';

const StyledButton = styled(Flex, { shouldForwardProp })<
  WithDivProps<SkeletonButtonProps>
>(base, wavesEffect, sx);

const SkeletonButton: FC<WithDivProps<SkeletonButtonProps>> = ({
  children,
  sx,
  ...rest
}) => (
  <StyledButton {...rest} sx={sx}>
    <Box width="80%">{children}</Box>
  </StyledButton>
);

export default SkeletonButton;
